import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';

// /settings/general — rota usa Index.vue direto (sem SettingsWrapper).
// Adota o padrao Studio: cada page e responsavel por seu layout via
// <PageLayout> + <PageHeader>, sem wrapper intermediario.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/general'),
      name: 'general_settings_index',
      meta: {
        permissions: ['administrator'],
      },
      component: Index,
    },
  ],
};
